import { render, staticRenderFns } from "./DashBoardInventario.vue?vue&type=template&id=8c91d58e&scoped=true&"
import script from "./DashBoardInventario.vue?vue&type=script&lang=js&"
export * from "./DashBoardInventario.vue?vue&type=script&lang=js&"
import style0 from "./DashBoardInventario.vue?vue&type=style&index=0&id=8c91d58e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c91d58e",
  null
  
)

export default component.exports